import React from 'react'
import Screen from 'containers/Screen'
import PromocaoBox from 'components/PromocaoJaneiro2026'

export default function PromocaoJaneiro2026Screen () {
  return (
    <Screen title={''}>
      <PromocaoBox />
    </Screen>
  )
}
